import React, { useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import * as Modal from '_components/modal/generic-modal'
import Checkbox from '_/components/checkbox'
import useStyles from '../styles'
import { reportCheckboxes } from './reportCheckboxes'

const DEFAULT_OPTIONS = {
  openDate: true,
  requesterName: true,
  ownerName: true,
  propertyCode: true,
  address: true,
  providerNameCnpj: true,
  description: true,
  budgetDescribed: true,
  budgetItemsWithValues: true,
  timelineOpen: true,
  timelineBudgetReceived: true,
  timelineBudgetApproved: true,
  timelineFinished: true,
  commentsPublic: true,
  attachmentsOpen: true,
  attachmentsFinished: true,
}

export default function ServiceOrderReportModal({ open, onClose, onGenerate, showToast }) {
  const styles = useStyles()
  const [options, setOptions] = useState(DEFAULT_OPTIONS)
  const firstColumnCheckboxes = reportCheckboxes.slice(0, 9)
  const secondColumnCheckboxes = reportCheckboxes.slice(9)

  const atLeastOneSelected = useMemo(() => Object.values(options).some(Boolean), [options])

  const handleChange = event => {
    const { name, value } = event.target
    setOptions(prev => ({ ...prev, [name]: value }))
  }

  const handleGenerate = () => {
    if (!atLeastOneSelected) {
      if (showToast)
        showToast({
          type: 'error',
          message: 'Selecione ao menos uma opção para gerar o relatório.',
        })
      return
    }
    if (onGenerate) onGenerate({ selectedOptions: options })
  }

  return (
    <Modal.Root open={open} onClose={onClose} disableEnforceFocus>
      <Modal.TitleModal title="Emitir relatório do chamado" />
      <Modal.Content className={styles.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} className={styles.modalColumn}>
            {firstColumnCheckboxes.map(({ name, label }) => (
              <Checkbox
                key={name}
                formClassName={styles.reportCheckbox}
                name={name}
                label={label}
                checked={options[name]}
                onChange={handleChange}
              />
            ))}
          </Grid>
          <Grid item xs={12} md={6} className={styles.modalColumn}>
            {secondColumnCheckboxes.map(({ name, label }) => (
              <Checkbox
                key={name}
                formClassName={styles.reportCheckbox}
                name={name}
                label={label}
                checked={options[name]}
                onChange={handleChange}
              />
            ))}
          </Grid>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Modal.ButtonRed onClick={onClose}>Cancelar</Modal.ButtonRed>
        <Modal.ButtonFullBlue onClick={handleGenerate}>Gerar relatório</Modal.ButtonFullBlue>
      </Modal.Actions>
    </Modal.Root>
  )
}
